/**
 * Attempts to detect the browser type
 * from the userAgent string.
 *
 * Notes:
 * Any errors will return "Unknown".
 *
 * @return {string} - the browser type
 */
export function getBrowserType(): string {
    try {
        const userAgent = navigator.userAgent;
        let browserType = "";

        if (userAgent.indexOf("Edg") > -1) {
            browserType = "Microsoft Edge";
        } else if (
            userAgent.indexOf("Chrome") > -1 ||
            userAgent.indexOf("CriOS") > -1
        ) {
            browserType = "Chrome";
        } else if (userAgent.indexOf("Safari") > -1) {
            browserType = "Safari";
        } else if (userAgent.indexOf("Opera") > -1) {
            browserType = "Opera";
        } else if (userAgent.indexOf("Firefox") > -1) {
            browserType = "Firefox";
        } else if (
            userAgent.indexOf("MSIE") > -1 ||
            userAgent.indexOf("Trident") > -1
        ) {
            browserType = "Internet Explorer";
        } else {
            browserType = "Unknown";
        }

        return browserType;
    } catch {
        return "Unknown";
    }
}

/**
 * Attempts to detect the browser version
 * from the userAgent string.
 *
 * Notes:
 * Any errors will return "Unknown".
 *
 * @return {string} - the browser version
 */
export function getBrowserVersion(): string {
    try {
        const userAgent = navigator.userAgent;
        let version: string | undefined = "";

        if (userAgent.indexOf("Edg") > -1) {
            version = /Edg\/([0-9.]+)/.exec(userAgent)?.[1];
        } else if (userAgent.indexOf("Chrome") > -1) {
            version = /Chrome\/([0-9.]+)/.exec(userAgent)?.[1];
        } else if (userAgent.indexOf("CriOS") > -1) {
            version = /CriOS\/([0-9.]+)/.exec(userAgent)?.[1];
        } else if (userAgent.indexOf("Safari") > -1) {
            version = /Version\/([0-9.]+)/.exec(userAgent)?.[1];
        } else if (userAgent.indexOf("Opera") > -1) {
            version = /Opera\/([0-9.]+)/.exec(userAgent)?.[1];
        } else if (userAgent.indexOf("Firefox") > -1) {
            version = /Firefox\/([0-9.]+)/.exec(userAgent)?.[1];
        } else if (userAgent.indexOf("MSIE") > -1) {
            version = /MSIE ([0-9.]+)/.exec(userAgent)?.[1];
        } else if (userAgent.indexOf("Trident") > -1) {
            version = /rv:([0-9.]+)/.exec(userAgent)?.[1];
        } else {
            version = "Unknown";
        }

        return version ?? "Unknown";
    } catch {
        return "Unknown";
    }
}

/**
 * Attempts to detect the device type
 * from the userAgent string.
 *
 * Notes:
 * Any errors will return "Unknown".
 *
 * @return {string} - the device type
 */
export function getDeviceType(): string {
    try {
        const userAgent = navigator.userAgent;

        if (/Android/i.test(userAgent)) {
            return "Android";
        } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
            return "iOS";
        } else if (/Windows Phone/i.test(userAgent)) {
            return "Windows Phone";
        } else if (/Linux/i.test(userAgent)) {
            return "Linux";
        } else if (/Macintosh/i.test(userAgent)) {
            return "Macintosh";
        } else if (/Windows/i.test(userAgent)) {
            return "Windows";
        } else {
            return "Unknown";
        }
    } catch {
        return "Unknown";
    }
}
